import { render, staticRenderFns } from "./TableBrandProfitability.vue?vue&type=template&id=4e1c77ae&"
import script from "./TableBrandProfitability.vue?vue&type=script&lang=js&"
export * from "./TableBrandProfitability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports